import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

export const PrestazioniCDIcon = props => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-2 -4 64 74"
      x="0px"
      y="0px"
    >
      <title>prestazioni_cd</title>
      <g>
        <rect x="36" y="9" width="2" height="2" />
        <rect x="8" y="35" width="2" height="2" />
        <rect x="20" y="45" width="2" height="2" />
        <path d="M44,24c-.33,0-.66,0-1,.05A4.93,4.93,0,0,0,42,23a5,5,0,0,0,2-4V9a5,5,0,0,0-5-5H7A5,5,0,0,0,2,9V19a5,5,0,0,0,2,4,5,5,0,0,0-2,4V37a5,5,0,0,0,2,4,5,5,0,0,0-2,4V55a5,5,0,0,0,5,5H39a4.82,4.82,0,0,0,1.68-.32A18.23,18.23,0,0,0,44,60a18,18,0,0,0,0-36ZM4,19H40V17H4V11H34V9H4A3,3,0,0,1,7,6H39a3,3,0,0,1,3,3H40v2h2v8a3,3,0,0,1-3,3H7A3,3,0,0,1,4,19ZM4,37H6V35H4V27a3,3,0,0,1,3-3H39a3,3,0,0,1,1.39.37A17.85,17.85,0,0,0,34,27v0H6v2H31.58a18.07,18.07,0,0,0-4.16,6H12v2H26.72a17.52,17.52,0,0,0-.6,3H7A3,3,0,0,1,4,37ZM4,47H18V45H4a3,3,0,0,1,3-3H26a18.59,18.59,0,0,0,.27,3H24v2h2.72a18,18,0,0,0,3.06,6H4ZM7,58a3,3,0,0,1-3-3H31.58a18.21,18.21,0,0,0,4.21,3ZM56.62,35.87l1.69-1A15.93,15.93,0,0,1,60,41H58v2h2a15.93,15.93,0,0,1-1.64,6.11l-1.69-1-1,1.74,1.7,1a16.12,16.12,0,0,1-4.47,4.47l-1-1.7-1.74,1,1,1.69A15.93,15.93,0,0,1,45,58V56H43v2a15.93,15.93,0,0,1-6.11-1.64l1-1.69-1.74-1-1,1.7a16.12,16.12,0,0,1-4.47-4.47l1.7-1-1-1.74-1.69,1A15.93,15.93,0,0,1,28.05,43H30V41H28.05a15.93,15.93,0,0,1,1.64-6.11l1.69,1,1-1.74-1.7-1a16.12,16.12,0,0,1,4.47-4.47l1,1.7,1.74-1-1-1.69A15.93,15.93,0,0,1,43,26.05V28h2V26.05a15.93,15.93,0,0,1,6.11,1.64l-1,1.69,1.74,1,1-1.7a16.12,16.12,0,0,1,4.47,4.47l-1.7,1Z" />
        <path d="M44,30A12,12,0,1,0,56,42,12,12,0,0,0,44,30Zm1,2a10,10,0,0,1,7.1,4.12l-5.25,3A4,4,0,0,0,45,38.14Zm-2,0v6.09a4,4,0,0,0-1.85,1.06l-5.25-3A10,10,0,0,1,43,32.05ZM34.89,46.1a9.89,9.89,0,0,1,0-8.2l5.27,3a3.59,3.59,0,0,0,0,2.12ZM43,52a10,10,0,0,1-7.1-4.12l5.25-3A4,4,0,0,0,43,45.86ZM42,42a2,2,0,1,1,2,2A2,2,0,0,1,42,42Zm3,10V45.86a4,4,0,0,0,1.85-1.06l5.25,3A10,10,0,0,1,45,52Zm9-10a9.86,9.86,0,0,1-.89,4.1l-5.27-3a3.59,3.59,0,0,0,0-2.12l5.27-3A9.86,9.86,0,0,1,54,42Z" />
      </g>
    </svg>
  </SvgIcon>
)

export const PrestazioniMeccanicaIcon = props => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      x="0px"
      y="0px"
    >
      <title>prestazioni_meccanica</title>
      <g>
        <path className="cls-1" d="M90.74,55c0,.07,0,.15,0,.22V55Z" />
        <path
          className="cls-1"
          d="M72.75,53.81c0,3.72,3.37,6.75,7.5,6.75H87.8v-4.5a11.45,11.45,0,0,0-.55-3.5H72.75Z"
        />
        <path
          className="cls-1"
          d="M66.7,78.45c0,3.67,3.07,6.7,7,7.08v-10h3v10h4v-10h3v10c3.95-.35,7-3.39,7-7.08V71.57h-24Z"
        />
        <path
          className="cls-1"
          d="M41.47,39.51a10.48,10.48,0,0,0-1.73,2.06H76.3a14.37,14.37,0,0,1,5.23,1L71.74,23.6a9.41,9.41,0,0,0-8.58-5H47.51a21,21,0,0,1-6,20.94Z"
        />
        <path
          className="cls-1"
          d="M87.8,63.57H80.25c-5.79,0-10.5-4.37-10.5-9.75V49.56h16a11.49,11.49,0,0,0-9.48-5H38.5a10.75,10.75,0,0,0-.25,2.3v4.7H59.7v3H38.25v4H59.73v3H38.25v7H87.8Z"
        />
        <circle cx="27.25" cy="83.06" r="1" />
        <path
          className="cls-1"
          d="M45.25,24.06a18,18,0,0,0-10-16.13V23.06a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V7.94A18,18,0,0,0,15.06,37.3a12.58,12.58,0,0,1,4.19,9.56V86.06a6,6,0,0,0,6,6h4a6,6,0,0,0,6-6V46.87a12.58,12.58,0,0,1,4.19-9.56A18,18,0,0,0,45.25,24.06Zm-18,63a4,4,0,1,1,4-4A4,4,0,0,1,27.25,87.06Z"
        />
      </g>
    </svg>
  </SvgIcon>
)

export const PrestazioniNuoveIcon = props => (
  <SvgIcon stroke={props.nativeColor} {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="10 -20 270 400"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="    M266.561,179.5c0,94.95-33.011,172.24-74.181,174.92v0.08H80.89c-10,0-19.55-4.4-28.3-12.4c-9.71-8.88-18.44-22.2-25.72-38.859    c-7.06-16.17-12.74-35.49-16.61-56.972c-1.15-6.339-2.13-12.869-2.94-19.559C5.48,211.689,4.5,195.86,4.5,179.5    c0-5.65,0.12-11.24,0.35-16.75c0.26-6.271,0.66-12.44,1.2-18.5c1.68-18.84,4.69-36.59,8.79-52.69    c1.45-5.739,3.05-11.27,4.77-16.569c5.28-16.222,11.76-30.271,19.13-41.46c3.04-4.631,6.24-8.76,9.57-12.36    C58.19,10.479,69.24,4.5,80.89,4.5h111.49v0.08C233.55,7.26,266.561,84.54,266.561,179.5z"
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="    M164.648,332.481c-12.887-16.476-20.81-36.258-26.545-56.209c-6.391-22.234-10.082-45.169-11.717-68.229    c-1.67-23.55-1.337-47.272,1.219-70.747c2.45-22.502,6.759-45.001,14.212-66.409c6.072-17.439,14.189-35.421,26.674-49.279    c1.443-1.604,2.953-3.145,4.539-4.605"
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="    M186.469,84.377c3.125-3.161,6.457-4.869,9.914-4.869c17.842,0,32.307,45.443,32.307,101.5c0,56.056-14.465,101.5-32.307,101.5    c-6.519,0-12.588-6.067-17.664-16.504"
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="    M248.471,182.597c0,71.547-21.307,129.549-47.588,129.549c-26.283,0-47.59-58.002-47.59-129.549    c0-71.549,21.307-129.55,47.59-129.55c10.965,0,21.064,10.097,29.111,27.063"
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <polyline
            points="    124.268,186.832 92.268,203.391 57.935,238.282 48.268,226.832 85.062,188.166 126.076,167.499   "
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="    M59,191.439l-9.67,11.45L21,170.001l-16.15-7.25c0.26-6.271,0.66-12.441,1.2-18.5l22.16,10.519L59,191.439z"
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <polyline
            points="    129.393,113.121 97.393,129.68 63.06,164.571 53.393,153.121 90.187,114.455 135.528,92.293   "
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="    M64.12,117.729l-9.66,11.45L28.12,97.29l-13.28-5.73c1.45-5.739,3.05-11.27,4.77-16.569l15.72,7.069L64.12,117.729z"
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <polyline
            points="    152.971,317.79 118.57,339.54 106.12,354.5 86.38,354.5 110.13,324.96 145.6,302.3   "
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <polyline
            points="    131.957,255.218 101.445,274.383 70.137,312.011 59.549,301.406 92.998,259.811 129.786,234.805   "
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="    M59.55,267.42l-8.68,12.21l-29.12-31.91l-11.49-1.45c-1.15-6.34-2.13-12.871-2.94-19.56l20.34,5.24L59.55,267.42z"
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="    M59.55,332.3l-6.96,9.8c-9.71-8.88-18.44-22.2-25.72-38.858L59.55,332.3z"
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <polyline
            points="    152.766,42.402 121.632,57.313 85.211,90.019 76.269,77.993 115.38,41.674 164.575,23.466   "
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <polyline
            points="    48.31,21.17 71.96,46.02 62.3,57.47 38.74,33.53   "
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <polyline
            points="    98.54,4.5 87.84,14.439 96.78,26.46 121.24,4.5   "
            fill="none"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
)

export const PrestazioniRevisioneIcon = props => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 20 512 480"
      xmlSpace="preserve"
    >
      <title>prestazioni_revisione</title>
      <g>
        <g>
          <path d="M275.6,224h31.6c-4.4-8.7-15-12.2-23.7-7.8C280.1,217.9,277.3,220.6,275.6,224z" />
        </g>
        <g>
          <path d="M329,319v6.5c0.2,4.2,3.6,7.5,7.8,7.5h12.9c4.1,0,7.3-3.4,7.3-7.4c0,0,0,0,0-0.1v-7.9c-2.3,0.9-4.8,1.4-7.3,1.4H329z" />
        </g>
        <g>
          <path d="M155,317.6v7.9c-0.1,4.1,3.1,7.4,7.2,7.5c0,0,0,0,0.1,0h12.9c4.2,0,7.7-3.3,7.8-7.5V319h-20.7    C159.8,319,157.3,318.5,155,317.6z" />
        </g>
        <g>
          <rect x="183" y="269" width="15" height="9" />
        </g>
        <g>
          <path d="M291.4,198.3c15.6-0.1,29.1,10.6,32.7,25.7h15.7l-12.5-29.2c-1.2-2.9-4-4.8-7.2-4.8H194.8c-3.1,0-6,1.9-7.2,4.8L175.2,224    h83.5C262.3,208.9,275.8,198.2,291.4,198.3z" />
        </g>
        <g>
          <path d="M330,77.7c0-7.1-5.8-12.8-12.9-12.7c0,0,0,0,0,0h-23c-3.8,0-7.1-2.7-7.8-6.4c-3.1-14.6-15.9-25-30.8-25    c-14.9,0-27.3,10.1-30.8,25.2c-0.8,3.6-4.1,6.2-7.8,6.2h-22.4c-6.8,0-12.4,5.5-12.4,12.3c0,0.1,0,0.3,0,0.4V119h148V77.7z" />
        </g>
        <g>
          <path d="M347.8,240H166.8l-6.5,5.5c-3.4,2.8-5.3,7-5.3,11.5v38.4c-0.1,4.1,3.2,7.5,7.3,7.6h187.4c4.1-0.1,7.4-3.5,7.3-7.6v-40.2    c0-4.1-1.7-8.1-4.7-10.9L347.8,240z M215,286c0,4.4-3.6,8-8,8h-32c-4.4,0-8-3.6-8-8v-25c0-4.4,3.6-8,8-8h32c4.4,0,8,3.6,8,8V286z     M274.3,285h-36.7c-4.4,0-8-3.6-8-8s3.6-8,8-8h36.7c4.4,0,8,3.6,8,8S278.8,285,274.3,285z M346,286c0,4.4-3.6,8-8,8h-32    c-4.4,0-8-3.6-8-8v-25c0-4.4,3.6-8,8-8h32c4.4,0,8,3.6,8,8V286z" />
        </g>
        <g>
          <path d="M394.9,101H346v26.3c0,4.3-3.6,7.7-7.9,7.7c-0.1,0-0.1,0-0.2,0H173.5c-4,0.1-7.4-3.1-7.5-7.1c0-0.2,0-0.4,0-0.5V101h-48.9    c-12.9,0-23.1,10.9-23.1,23.7v330.4c0,12.6,10.2,22.8,22.7,22.9c0.1,0,0.3,0,0.4,0h277.7c12.6,0.2,23-9.9,23.1-22.5    c0-0.1,0-0.3,0-0.4V124.7C418,111.9,407.7,101,394.9,101z M361.4,435H150.6c-4.4,0-8-3.6-8-8s3.6-8,8-8h210.9c4.4,0,8,3.6,8,8    S365.9,435,361.4,435z M142.6,385c0-4.4,3.6-8,8-8h116.9c4.4,0,8,3.6,8,8s-3.6,8-8,8H150.6C146.1,393,142.6,389.4,142.6,385z     M373,291.5v34c0.1,12.9-10.3,23.4-23.2,23.5c0,0,0,0,0,0h-12.9c-12.9,0-23.8-10.6-23.8-23.5V319H199v6.5    c0,12.9-10.9,23.5-23.8,23.5h-12.9c-12.9-0.1-23.3-10.6-23.3-23.5c0,0,0,0,0,0v-68.6c0-9.1,4-17.8,10.9-23.8l6.1-5.2l17-39.5    c3.7-8.7,12.4-14.4,21.9-14.4h125.4c9.5,0,18.1,5.7,21.9,14.4l17.3,40.2c0,0,0,0.1,0,0.1l3.9,3.7c6.2,5.9,9.7,14.1,9.7,22.7V291.5    z" />
        </g>
        <g>
          <rect x="314" y="269" width="15" height="9" />
        </g>
      </g>
    </svg>
  </SvgIcon>
)
